var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dot all:flex justify-center align-center",class:[`dot__${_vm.size}`, `dot__${_vm.colour}`, _vm.position, { inverted: _vm.invert }]},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }